// extracted by mini-css-extract-plugin
export default {"wrapCategoryProduct":"Modal_wrapCategoryProduct__WX17Y","containerCategoryProduct":"Modal_containerCategoryProduct__1I8Kr"};